import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { logErrorFromMicroservicesSdk } from '@sxm-de/dev-kits/web-sdk/utils';

interface SendRefreshInstructionsFnPayload {
    phone: string;
    radioId: string;
    languagePreference?: string;
}

export type SendRefreshInstructionsStatus = 'SUCCESS' | 'FAILURE';

export type SendRefreshInstructionsFn = (
    payload: SendRefreshInstructionsFnPayload,
) => Promise<{
    status: SendRefreshInstructionsStatus;
}>;

export function initSendRefreshInstructionsFn({
    dependencies,
}: DomainInitPayload): SendRefreshInstructionsFn {
    const { microservicesSdk } = dependencies;
    return async (payload: SendRefreshInstructionsFnPayload) => {
        try {
            return await microservicesSdk.domains.device.sendRefreshInstruction(
                payload,
            );
        } catch (error: any) {
            logErrorFromMicroservicesSdk(error, dependencies);
            throw new Error('SYSTEM');
        }
    };
}
